import axios from "axios";
import { env } from "../../env";
import { RPC_TERMS_ENDPOINTS } from "../endpoints";

const BASE_URL = env.REACT_APP_CLIENT_API_URL || "";

export const getRegisterAgeList = async () => {
    const response = await axios.post(
        `${BASE_URL}${RPC_TERMS_ENDPOINTS.GET_ACCOUNT_AGE_LIST}`,
        {},
        { headers: { "Content-Type": "application/json" } }
    );
    const data = response?.data;
    const list = Array.isArray(data) ? data : (data?.Data || data?.data || []);
    return list.map((item) => ({
        value: String(item?.Id ?? item?.id ?? ""),
        label: item?.Title || item?.title || "",
    })).filter((item) => item.value && item.label);
};

export const getCountryList = async () => {
    const response = await axios.post(
        `${BASE_URL}${RPC_TERMS_ENDPOINTS.GET_COUNTRY_LIST}`,
        {},
        { headers: { "Content-Type": "application/json" } }
    );
    const data = response?.data;
    const list = Array.isArray(data) ? data : (data?.Data || data?.data || []);
    return list.map((item) => ({
        value: String(item?.Id ?? item?.id ?? ""),
        label: item?.Title || item?.title || "",
    })).filter((item) => item.value && item.label);
};

export const getRegisterCategories = async (language = "en") => {
    const response = await axios.post(
        `${BASE_URL}${RPC_TERMS_ENDPOINTS.GET_REGISTER_CATEGORIES}`,
        {},
        { headers: { "Content-Type": "application/json" } }
    );
    const data = response?.data;
    const list = Array.isArray(data) ? data : (data?.Data || data?.data || []);
    return list.map((item) => {
        const nameGr = item?.categoryname || "";
        const nameEn = item?.CategoryNameEnglish || item?.categoryNameEnglish || nameGr;
        const label = language === "gr" || language === "el" ? nameGr : nameEn;
        return {
            value: String(item?.categoryid ?? item?.CategoryId ?? ""),
            label: label || nameEn || nameGr,
        };
    }).filter((item) => item.value && item.label);
};
